// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const FiveStarsNoBorder = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 136 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="m12 0 2.694 8.292h8.719l-7.054 5.124 2.694 8.292L12 16.584l-7.053 5.124 2.694-8.292L.587 8.292h8.719L12 0ZM40 0l2.694 8.292h8.719l-7.054 5.124 2.694 8.292L40 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719L40 0ZM68 0l2.694 8.292h8.719l-7.054 5.124 2.694 8.292L68 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719L68 0ZM96 0l2.694 8.292h8.719l-7.054 5.124 2.694 8.292L96 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719L96 0ZM124 0l2.694 8.292h8.719l-7.054 5.124 2.694 8.292L124 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719L124 0Z"
			fill="#fff"
		/>
	</svg>
);
export default FiveStarsNoBorder;
